import { render, staticRenderFns } from "./AudioRecording.vue?vue&type=template&id=8a22b324&"
import script from "./AudioRecording.vue?vue&type=script&lang=js&"
export * from "./AudioRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports